<template>
    <div class="main-container">
        <!-- Navbar section -->
        <Navbar id="navbar" />

        <!-- hero section -->
        <HeroHome class="hero-sass" />

        <MissionStatement />

        <!-- TryItOut component -->
        <TryItOut id="try-it-out" />

        <!-- banner one component -->
        <BannerHome class="banner-one-sass" id="about" />

        <!-- sass feature component -->
        <FeatureHome class="gray-gradient" id="services" />

        <Banner class="banner-one-sass bg-gray-3" id="support" />

        <!-- footer section -->
        <FooterMain />

    </div>
</template>

<script>
import Navbar from "../comp_trustami/Navbar";
import HeroHome from "../comp_trustami/HeroHome";
import BannerHome from "../comp_trustami/BannerHome";
import TryItOut from "../comp_trustami/TryItOut";
import Banner from '../comp_trustami/Banner';
import MissionStatement from '../comp_trustami/MissionStatement';
import FeatureHome from "../comp_trustami/FeatureHome";
import FooterMain from "../comp_trustami/FooterMain";

export default {
    name: "app",
    components: {
        Navbar,
        HeroHome,
        BannerHome,
        FeatureHome,
        Banner,
        MissionStatement,
        FooterMain,
        TryItOut
    },
    metaInfo: {
        title: 'Trustami.AI Web Services',
        meta: [
            {
                name: 'description',
                content: 'Make sense of your natural language data. TWS offers several ai-baked services for common NLP tasks. All services are shipped as easy-to-use RESTful APIs.'
            }
        ],
        htmlAttrs: {
            lang: 'en',
            amp: true
        }
    }
};
</script>
